export default {
  messages: {
    en: {
      aside: {
        actions: {
          viewAll: {
            label: `View all news`,
          },
        },
        heading: `Recent news`,
      },
    },
  },
}
